import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, forwardRef, HostListener, Inject, ViewChild, ViewContainerRef } from '@angular/core';
import { AlertController, Events, ModalController, ToastController } from 'ionic-angular';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';
import { ComponentServiceProvider } from '../../providers/component-service/component-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ProposalComponent } from '../proposal/proposal';
import { AddClientDetailsComponent } from '../add-client-details/add-client-details';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';

declare var jQuery;
const DEFAULTVALUE = 0;

@Component({
  selector: 'cover-screen',
  templateUrl: 'cover-screen.html'
})
export class CoverScreenComponent {
  public userImage: object = [];
  tabName: any = 'ProposalViewer';
  currentDate = new Date();
  userCode: any;
  defSettings: any = {
    bigBanner: false,
    timePicker: false,
    format: 'dd-MMM-yyyy',
    defaultOpen: false,
  }
  dateFormat = 'dd-MMM-yyyy';
  selectedDate: any;
  ClientCodeArr: any = [];
  showClientCode: boolean = false;
  currentdate = new Date();
  activatedSheet: any = [];
  mergePage: any = [];
  pdfFileName: any = '';
  tabTemplates: any = [];
  msaFileName: any;
  propslFileName: any;
  ServicesStatus: any;
  serviceAction: any;
  selecetdFile: File;
  componentRef: any;
  ClientCodeResp: any = [];
  AddClientResp: any = [];
  target: EventTarget;
  errorMsg: any = '';
  publishCount: any = 0;
  @ViewChild('container', {
    read: ViewContainerRef,
  }) viewContainerRef: ViewContainerRef;
  showProposal: boolean = false;
  publishStatus: boolean = false;
  broadcastSubs: any;
  dragging: boolean = false;
  loaded: boolean = false;
  imageLoaded: boolean = false;
  constructor(
    public communicationServ: CommunicationServiceProvider,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private resolver: ComponentFactoryResolver,
    public toastController: ToastController,
    public configApiService: ConfigApiServiceProvider,
    public cdr: ChangeDetectorRef,
    public datePipe: DatePipe,
    public dataService: DataServiceProvider,
    public event: Events,
    public priceListTableService: PriceListTableProvider,
    @Inject(forwardRef(() => ComponentServiceProvider)) public componentService: ComponentServiceProvider
  ) {
  }
  ngOnInit() {
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: false, params: {}});
    this.dataService.goBack = 'DASHBOARD';
    if (localStorage.getItem('MSPForm')) {
      let formData = localStorage.getItem('MSPForm');
      let formVal = JSON.parse(formData);
      this.dataService.ProposalTable.mspForm = formVal
    } else {
      this.dataService.ProposalTable.mspForm.startDate = this.datePipe.transform(this.dataService.ProposalTable.mspForm.startDate, this.dateFormat);
      this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
        element.overrideDate = this.datePipe.transform('', this.dateFormat);
      });
      this.dataService.ProposalTable.mspForm.msaData.newDate = this.datePipe.transform(this.dataService.ProposalTable.mspForm.msaData.newDate, this.dateFormat);
      this.dataService.ProposalTable.mspForm.msaData.existingDate = this.datePipe.transform(this.dataService.ProposalTable.mspForm.msaData.existingDate, this.dateFormat);
      this.dataService.ProposalTable.mspForm.proposalDate = this.datePipe.transform(this.dataService.ProposalTable.mspForm.proposalDate, this.dateFormat);
      this.dataService.ProposalTable.mspForm.proposedStartDate = this.datePipe.transform(this.dataService.ProposalTable.mspForm.proposedStartDate, this.dateFormat);
    }
    if (this.dataService.ProposalTable.mspForm.userSignature != '') {
      var filename = this.dataService.ProposalTable.mspForm.userSignature.split('/').pop()
      var body = { "fileName": filename }
      this.configApiService.downloadFile(body, this.cbk);
    }
    let starportUrls = 'https://drive.prodcast.cloud:3784/uploads/starport-managed-services.png';
    var imgname = starportUrls.split('/').pop()
    var bodyData = { "fileName": imgname }
    this.configApiService.devDownloadFile(bodyData, this.devcbk);
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "proposal-create") {
          if (data.event === 'ClientDetails') {
            if (data.status === true) {
              this.AddClientDetailsResp();
            }
          }
        }
      });
  }
  devcbk = ((resData) => {
    this.dataService.StarportLogo = 'data:image/png;base64,' + resData;
  })
  cbk = ((resData) => {
    this.dataService.UserSignature = 'data:image/png;base64,' + resData;
  });
  handleDragEnter() {
    this.dragging = true;
  }
  handleDragLeave() {
    this.dragging = false;
  }
  onDragover() {
    return false;
  }
  handleDrop(e) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
  }
  handleImageLoad() {
    this.imageLoaded = true;
  }
  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      const toast = this.toastController.create({
        message: 'Please Select Only Image',
        duration: 1000,
      });
      toast.present();
      return;
    }
    this.loaded = false;
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    var reader = e.target;
    this.ClientCodeArr.forEach(element => {
      if (element.clientCode == this.dataService.ProposalTable.mspForm.ClientCode) {
        let obj1 = {
          "Client_Details_1_Id": element.Client_Details_1_Id,
          "clientCode": element.clientCode,
          "companyName": element.companyName,
          "salutation": element.salutation,
          "firstName": element.firstName,
          "lastName": element.lastName,
          "address": element.address,
          "city": element.city,
          "province": element.province,
          "postal": element.postal,
          "phone": element.phone,
          "emailID": element.emailID,
          "clientLogo": reader.result,
          "userid": 3280,
          "rptname": "Client_Details_12281",
          "client": "starport1294",
          "status": "",
          "Tag": "",
          "Created_date": "",
          "Created_By": "",
          "Modified_By": "",
          "Modified_date": "",
        }
        let objData1 = { data: JSON.stringify(obj1) }
        this.configApiService.saveContract(objData1).subscribe((respdata: any) => {
              this.AddClientResp = respdata;
              this.AddClientDetailsResp();
        });
        this.dataService.ProposalTable.mspForm.ClientLogo = reader.result;
        this.loaded = true;
      }
    });
  }
  ngAfterViewInit() {
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.overrideDate == null) {
        var classIds = '#' + element.name + 'OrDate' + " .wc-date-container span"
        jQuery(classIds).text("");
      }
    });
    if (this.dataService.ProposalTable.mspForm.startDate == null) {
      jQuery(".sowDate .wc-date-container span").text("");
    }
    if (this.dataService.ProposalTable.mspForm.msaData.newDate == null) {
      jQuery(".msaNewDate .wc-date-container span").text("");
    }
    if (this.dataService.ProposalTable.mspForm.msaData.existingDate == null) {
      jQuery(".msaExistingDate .wc-date-container span").text("");
    }
    if (this.dataService.ProposalTable.mspForm.proposalDate == null) {
      jQuery(".propslDate .wc-date-container span").text("");
    }
    if (this.dataService.ProposalTable.mspForm.proposedStartDate == null) {
      jQuery(".propslStartDate .wc-date-container span").text("");
    }
    let obj = { "start": 1, "end": 1000, "userid": 3280, "rptname": "User_detatils2440", "client": "starport1294" }
    let objData = { data: JSON.stringify(obj) }
    this.configApiService.getContractList(objData).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          this.userCode = JSON.parse(respdata["_POST_SummaryMethodResult"]);
        }
      }
    });
    this.AddClientDetailsResp();
  }
  AddClientDetailsResp() {
    let obj1 = { "start": 1, "end": 1000, "userid": 3280, "rptname": "Client_Details_12281", "client": "starport1294" }
    let objData1 = { data: JSON.stringify(obj1) }
    this.configApiService.getContractList(objData1).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          this.AddClientResp = JSON.parse(respdata["_POST_SummaryMethodResult"]);
          this.ClientResp();
        }
      }
    });
  }
  ClientResp() {
    let url = 'https://time.starport.ca:62226/EPC_V3.svc/summary/';
    let obj = { "start": 1, "end": 1000, "userid": "3287", "rptname": "Client268", "client": "Billing41001" }
    let objData = { data: JSON.stringify(obj) }
    this.configApiService.getClientSummaryAPi(url, objData).subscribe((respdata: any) => {
      if (respdata["_POST_SummaryMethodResult"].length > 0) {
        if (respdata["_POST_SummaryMethodResult"] !== "FAIL") {
          this.ClientCodeResp = JSON.parse(respdata["_POST_SummaryMethodResult"]);
          this.MergeCientDetails();
        }
      }
    });
  }
  MergeCientDetails() {
    if (this.AddClientResp.length > 0 || this.ClientCodeResp.length > 0) {
      const FilteredIdx = 0;
      this.ClientCodeResp.forEach(elem => {
        var filterData = this.AddClientResp.filter(element => element.clientCode.toLowerCase() == elem.ClientCode.toLowerCase())
        if (filterData.length == FilteredIdx) {
          let obj = {
            "clientCode": elem.ClientCode,
            "companyName": elem.Client_name,
            "salutation": '',
            "firstName": elem.FirstName,
            "lastName": elem.LastName,
            "address": '',
            "city": '',
            "province": '',
            "postal": '',
            "phone": elem.Phone,
            "emailID": '',
            "clientLogo": '',
            "userid": 3280,
            "rptname": "Client_Details_12281",
            "client": "starport1294",
            "status": "",
            "Tag": "",
            "Created_date": "",
            "Created_By": "",
            "Modified_By": "",
            "Modified_date": "",
          }
          let objData = { data: JSON.stringify(obj) }
          this.configApiService.saveContract(objData).subscribe(respdata => {
            if (respdata["_POST_AddMethodResult"].length > 0) {
              if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
                this.AddClientResp.concat(JSON.parse(respdata["_POST_SummaryMethodResult"]));
              }
            }
          });
        }
      });
    }
    this.ClientCodeArr = this.AddClientResp.sort((a, b) => a.clientCode.localeCompare(b.clientCode, 'es', { sensitivity: 'base' }))
  }
  OverrideDate(e, tab) {
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.name == tab) {
        let setDate = this.datePipe.transform(e, this.dateFormat);
        element.overrideDate = setDate;
        var classIds = '#' + element.name + 'OrDate' + " .wc-date-container span"
        jQuery(classIds).text(element.overrideDate);
      }
    });
  }
  optDescription(event, tab) {
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.name == tab) {
        element.optionalDescription = event.target.value;
      }
    });
  }
  onDateSelect(e, tab) {
    if (tab == 'SOW_DATE') {
      let setDate = this.datePipe.transform(e, this.dateFormat);
      this.dataService.ProposalTable.mspForm.startDate = setDate;
      jQuery(".sowDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.startDate);
    } else if (tab == 'MSA_NEW_DATE') {
      let setDate = this.datePipe.transform(e, this.dateFormat);
      this.dataService.ProposalTable.mspForm.msaData.newDate = setDate;
      jQuery(".msaNewDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.msaData.newDate);
    } else if (tab == 'MSA_EXISTING_DATE') {
      let setDate = this.datePipe.transform(e, this.dateFormat);
      this.dataService.ProposalTable.mspForm.msaData.existingDate = setDate;
      jQuery(".msaExistingDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.msaData.existingDate);
    } else if (tab == 'PROPOSAL_DATE') {
      let setDate = this.datePipe.transform(e, this.dateFormat);
      this.dataService.ProposalTable.mspForm.proposalDate = setDate;
      jQuery(".msaExistingDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.proposalDate);
    } else if (tab == 'PROPOSAL_START_DATE') {
      let setDate = this.datePipe.transform(e, this.dateFormat);
      this.dataService.ProposalTable.mspForm.proposedStartDate = setDate;
      jQuery(".msaExistingDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.proposedStartDate);
    }
  }

  filterFunction(event) {
    var input, filter, ul, li, a, i;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    var div = document.getElementById("myDropdown");
    a = div.getElementsByTagName("a");
    for (i = 0; i < a.length; i++) {
      var txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
    this.ClientCode(filter);
  }

  @ViewChild("searchInput") insideElement;
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (this.insideElement) {
      const clickedInside = this.insideElement.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.showClientCode = false;
      } else {
        this.showClientCode = true;
      }
    }
  }
  selectedClient(val) {
    this.ClientCode(val);
    this.showClientCode = false;
  }

  ClientCode(val) {
    this.dataService.ProposalTable.mspForm.ClientCode = val;
    var newArray: any = [];
    newArray = this.ClientCodeArr.filter(el => el.clientCode == this.dataService.ProposalTable.mspForm.ClientCode);
    if (newArray.length != 0) {
      this.dataService.ProposalTable.mspForm.ClientCompanyName = newArray[0].companyName;
      this.dataService.ProposalTable.mspForm.ClientFullName = newArray[0].salutation + ' ' + newArray[0].firstName + ' ' + newArray[0].lastName;
      this.dataService.ProposalTable.mspForm.ClientLastName = newArray[0].lastName;
      this.dataService.ProposalTable.mspForm.ClientSalutation = newArray[0].salutation;
      this.dataService.ProposalTable.mspForm.ClientAddress = newArray[0].address;
      this.dataService.ProposalTable.mspForm.ClientCity = newArray[0].city;
      this.dataService.ProposalTable.mspForm.ClientProvince = newArray[0].province;
      this.dataService.ProposalTable.mspForm.ClientPostal = newArray[0].postal;
      this.dataService.ProposalTable.mspForm.ClientLogo = newArray[0].clientLogo;
    } else {
      this.dataService.ProposalTable.mspForm.ClientCompanyName = '';
      this.dataService.ProposalTable.mspForm.ClientFullName = '';
      this.dataService.ProposalTable.mspForm.ClientLastName = '';
      this.dataService.ProposalTable.mspForm.ClientSalutation = '';
      this.dataService.ProposalTable.mspForm.ClientAddress = '';
      this.dataService.ProposalTable.mspForm.ClientCity = '';
      this.dataService.ProposalTable.mspForm.ClientProvince = '';
      this.dataService.ProposalTable.mspForm.ClientPostal = '';
    }
  }

  ClickSheet(tab) {
    var pageContent: any = [];
    var NoData: any = [];
    let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalCreate')
    pageContent = this.componentService.tabTemplates[index].templates;
    if (this.dataService.ProposalTable.mspForm.noOfUsers != '' && this.dataService.ProposalTable.mspForm.noOfDevices != '' && this.dataService.ProposalTable.mspForm.noOfLocations != '' && this.dataService.ProposalTable.mspForm.Mailboxes != '') {
      if (tab == 'HW' && (this.dataService.ProposalTable.mspForm.startDate == '' || this.dataService.ProposalTable.mspForm.startDate == null)) {
        NoData.push('SOW Date')
        this.AlertPopup(NoData);
      } else {
        pageContent.forEach(elem => {
          if (elem.sheetId == tab) {
            this.dataService.broadcastInfo({ src: 'proposal-create', event: 'OPEN_PAGE', params: elem, tab: 'ProposalCreate'});
          }
        });
      }
    } else {
      let user = this.dataService.ProposalTable.mspForm.noOfUsers != '' ? '' : 'Users';
      let device = this.dataService.ProposalTable.mspForm.noOfDevices != '' ? '' : 'Devices';
      let location = this.dataService.ProposalTable.mspForm.noOfLocations != '' ? '' : 'Locations';
      let mailbox = this.dataService.ProposalTable.mspForm.Mailboxes != '' ? '' : 'Mailboxes';
      NoData.push(user, device, location, mailbox)
      this.AlertPopup(NoData);
    }
  }

  AlertPopup(msg) {
    msg.forEach(element => {
      this.errorMsg += element + ', ';
    });
    let alert = this.alertCtrl.create({
      title: 'Config Setup',
      message: 'Please set values for ' + this.errorMsg,
      buttons: [{
        text: 'Ok',
        role: 'cancel',
        handler: () => {
          this.errorMsg = '';
        }
      }]
    });
    alert.present();
  }
  ngAfterViewChecked() {
    var currentDate: any = this.currentdate.getDate().toString();
    var randomGenerator = currentDate.padStart(2, '0') + this.currentdate.getHours() + this.currentdate.getMinutes();
    if (this.showProposal == false) {
      if (this.dataService.ProposalTable.mspForm.ClientCode == '') {
        this.dataService.ProposalTable.mspForm.msaData.fileName = 'WARNING: Need Client Code for MSA';
        this.msaFileName = 'warning';
      } else if (this.dataService.ProposalTable.mspForm.msaData.newDate == null && this.dataService.ProposalTable.mspForm.msaData.existingDate == null) {
        this.dataService.ProposalTable.mspForm.msaData.fileName = 'WARNING: Need an MSA Date';
        this.msaFileName = 'warning';
      } else if (this.dataService.ProposalTable.mspForm.msaData.newDate != null && this.dataService.ProposalTable.mspForm.msaData.existingDate != null) {
        this.dataService.ProposalTable.mspForm.msaData.fileName = "WARNING: Can't have an MSA with with both a New and Existing Date";
        this.msaFileName = 'warning';
      } else if (this.dataService.ProposalTable.mspForm.msaData.newDate == null && this.dataService.ProposalTable.mspForm.msaData.existingDate != null) {
        this.dataService.ProposalTable.mspForm.msaData.fileName = this.dataService.ProposalTable.mspForm.ClientCode + '-MSA--' + this.dataService.ProposalTable.mspForm.msaData.existingDate.replace(/-/g, "") + '--REV--' + this.dataService.ProposalTable.mspForm.msaData.existingNo + '.pdf';;
        this.msaFileName = '';
      } else if (this.dataService.ProposalTable.mspForm.msaData.newDate != null && this.dataService.ProposalTable.mspForm.msaData.existingDate == null) {
        this.dataService.ProposalTable.mspForm.msaData.fileName = this.dataService.ProposalTable.mspForm.ClientCode + '-MSA--' + this.dataService.ProposalTable.mspForm.msaData.newDate.replace(/-/g, "") + '--REV--' + this.dataService.ProposalTable.mspForm.msaData.revNo + '.pdf';;
        this.msaFileName = '';
      }
      if (this.dataService.ProposalTable.mspForm.userCode == '') {
        this.serviceAction = 'warning';
        this.ServicesStatus = 'WARNING: Need User Code to Preview/Publish a Service Line';
      } else if (this.dataService.ProposalTable.mspForm.ClientCode == '') {
        this.serviceAction = 'warning';
        this.ServicesStatus = 'WARNING: Need Client Code Preview/Publish a Service Line';
      } else if (this.dataService.ProposalTable.mspForm.noOfUsers == '' && this.dataService.ProposalTable.mspForm.noOfDevices == '' && this.dataService.ProposalTable.mspForm.noOfLocations == '' && this.dataService.ProposalTable.mspForm.Mailboxes == '') {
        this.serviceAction = 'warning';
        this.ServicesStatus = 'WARNING: Header Data Not Complete';
      } else if (this.dataService.ProposalTable.mspForm.nextSowNo == '') {
        this.serviceAction = 'warning';
        this.ServicesStatus = 'WARNING: ***** Enter Next SOW Number   ******';
      } else if (this.dataService.ProposalTable.mspForm.startDate == '') {
        this.serviceAction = 'warning';
        this.ServicesStatus = 'WARNING: ***** Enter SOW Date   ******';
      } else if (this.dataService.ProposalTable.mspForm.totalDashboardOneTime == '' && this.dataService.ProposalTable.mspForm.totalDashboardMonthly == '') {
        this.serviceAction = 'warning';
        this.ServicesStatus = 'WARNING: No Service Line Data has been Entered';
      } else if (this.dataService.ProposalTable.mspForm.longDescription == '') {
        this.serviceAction = 'warning';
        this.ServicesStatus = 'WARNING-Need Both Project Short & Long Description';
      } else {
        this.serviceAction = '';
        this.ServicesStatus = 'Okay to View / Publish';
      }
      if (this.dataService.ProposalTable.mspForm.userCode == '') {
        this.propslFileName = 'warning';
        this.dataService.ProposalTable.mspForm.proposalFileName = 'WARNING: Need User Code to Publish a PROPOSAL';
      } else if (this.dataService.ProposalTable.mspForm.ClientCode == '') {
        this.propslFileName = 'warning';
        this.dataService.ProposalTable.mspForm.proposalFileName = 'WARNING: Need Client Code to Publish a PROPOSAL';
      } else if (this.dataService.ProposalTable.mspForm.proposalDate == '' || this.dataService.ProposalTable.mspForm.proposalDate == null) {
        this.propslFileName = 'warning';
        this.dataService.ProposalTable.mspForm.proposalFileName = 'WARNING: ***** Enter Proposal date   ******';
      } else if (this.dataService.ProposalTable.mspForm.proposedStartDate == '' || this.dataService.ProposalTable.mspForm.proposedStartDate == null) {
        this.propslFileName = 'warning';
        this.dataService.ProposalTable.mspForm.proposalFileName = 'WARNING: ***** Enter Proposed Start  date   ******';
      } else if (this.dataService.ProposalTable.mspForm.proposalTitle == '') {
        this.propslFileName = 'warning';
        this.dataService.ProposalTable.mspForm.proposalFileName = ' WARNING: ***** Enter Proposal Title   ******';
      } else if (this.dataService.ProposalTable.mspForm.totalDashboardOneTime == '' && this.dataService.ProposalTable.mspForm.totalDashboardMonthly == '') {
        this.propslFileName = 'warning';
        this.dataService.ProposalTable.mspForm.proposalFileName = 'WARNING: No Service Line Data has been Entered';
      } else {
        this.propslFileName = '';
        this.dataService.ProposalTable.mspForm.proposalFileName = this.dataService.ProposalTable.mspForm.ClientCode + '-PPSL-' + this.dataService.ProposalTable.mspForm.proposalDate.replace(/-/g, "") + '-' + this.dataService.ProposalTable.mspForm.scenarioName + '-' + randomGenerator + '.pdf';
      }
      var projectScreenData = JSON.parse(localStorage.getItem('ProjectScreen'));
      var hwSwScreenData = JSON.parse(localStorage.getItem('HWSWScreenData'));
      var backupDrData = JSON.parse(localStorage.getItem('BACKUPDRsScreenData'));
      var cloudData = JSON.parse(localStorage.getItem('CLOUDScreenData'));
      var cyberScreenData = JSON.parse(localStorage.getItem('CYBERScreenData'));
      var mspScreenData = JSON.parse(localStorage.getItem('MSPScreenData'));
      this.activatedSheet = [];
      this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
        if (element.activate == true) {
          if (this.activatedSheet.includes(element.name) == false) {
            this.activatedSheet.push(element.name);
          }
        }
      });
      if (projectScreenData != null) {
        if (projectScreenData.projectService.TotalProjectService != '' || projectScreenData.Hslw.totalHslw != '') {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'PJT') {
              element.activate = true;
              element.fileName = this.dataService.ProposalTable.mspForm.ClientCode + '-SOW-' + (element.sowNo != '' ? element.sowNo.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) : '00') + '-' + element.name + '-' + this.dataService.ProposalTable.mspForm.scenarioName + '-' + randomGenerator + '.pdf';
              element.oneTime = projectScreenData.projectService.TotalProjectService;
              element.monthly = projectScreenData.Hslw.totalHslw;
            }
          });
        } else {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'PJT') {
              element.activate = false;
              element.fileName = '';
              element.oneTime = '';
              element.monthly = '';
            }
          });
        }
      } else {
        this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
          if (element.name == 'PJT') {
            element.activate = false;
            element.fileName = '';
            element.oneTime = '';
            element.monthly = '';
          }
        });
      }
      if (hwSwScreenData != null) {
        if (hwSwScreenData.TotalExtendedPrice != '' || hwSwScreenData.TotalMonthlyLeaseAmt != '') {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'HW') {
              element.activate = true;
              element.fileName = this.dataService.ProposalTable.mspForm.ClientCode + '-SOW-' + (element.sowNo != '' ? element.sowNo.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) : '00') + '-' + element.name + 'S-' + this.dataService.ProposalTable.mspForm.scenarioName + '-' + randomGenerator + '.pdf';
              element.oneTime = hwSwScreenData.TotalExtendedPrice;
              element.monthly = hwSwScreenData.TotalMonthlyLeaseAmt;
            }
          });
        }else {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'HW') {
              element.activate = false;
              element.fileName = '';
              element.oneTime = '';
              element.monthly = '';
            }
          });
        }
      } else {
        this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
          if (element.name == 'HW') {
            element.activate = false;
            element.fileName = '';
            element.oneTime = '';
            element.monthly = '';
          }
        });
      }
      if (backupDrData != null) {
        if (backupDrData.totalBackupDrServiceOneTimeFees != '' || backupDrData.BackupFeesummaryTotaly != '') {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'BKP') {
              element.activate = true;
              element.fileName = this.dataService.ProposalTable.mspForm.ClientCode + '-SOW-' + (element.sowNo != '' ? element.sowNo.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) : '00') + '-' + element.name + '-' + this.dataService.ProposalTable.mspForm.scenarioName + '-' + randomGenerator + '.pdf';
              element.oneTime = backupDrData.totalBackupDrServiceOneTimeFees;
              element.monthly = backupDrData.BackupFeesummaryTotaly;
            }
          });
        }else {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'BKP') {
              element.activate = false;
              element.fileName = '';
              element.oneTime = '';
              element.monthly = '';
            }
          });
        }
      } else {
        this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
          if (element.name == 'BKP') {
            element.activate = false;
            element.fileName = '';
            element.oneTime = '';
            element.monthly = '';
          }
        });
      }
      if (cloudData != null) {
        if (cloudData.FeesummaryMonthlyTotal != '' || cloudData.TotalStartUp != '') {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'CLD') {
              element.activate = true;
              element.fileName = this.dataService.ProposalTable.mspForm.ClientCode + '-SOW-' + (element.sowNo != '' ? element.sowNo.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) : '00') + '-' + element.name + '-' + this.dataService.ProposalTable.mspForm.scenarioName + '-' + randomGenerator + '.pdf';
              element.oneTime = cloudData.TotalStartUp;
              element.monthly = cloudData.FeesummaryMonthlyTotal;
            }
          });
        }else {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'CLD') {
              element.activate = false;
              element.fileName = '';
              element.oneTime = '';
              element.monthly = '';
            }
          });
        }
      } else {
        this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
          if (element.name == 'CLD') {
            element.activate = false;
            element.fileName = '';
            element.oneTime = '';
            element.monthly = '';
          }
        });
      }
      if (cyberScreenData != null) {
        if (cyberScreenData.oneTimeFee.TotalStartUp != '' || cyberScreenData.totalBackupDrMonthlyTool != '') {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'CYB') {
              element.activate = true;
              element.fileName = this.dataService.ProposalTable.mspForm.ClientCode + '-SOW-' + (element.sowNo != '' ? element.sowNo.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) : '00') + '-' + element.name + '-' + this.dataService.ProposalTable.mspForm.scenarioName + '-' + randomGenerator + '.pdf';
              element.oneTime = cyberScreenData.oneTimeFee.TotalStartUp;
              element.monthly = cyberScreenData.totalBackupDrMonthlyTool;
            }
          });
        }else {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'CYB') {
              element.activate = false;
              element.fileName = '';
              element.oneTime = '';
              element.monthly = '';
            }
          });
        }
      } else {
        this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
          if (element.name == 'CYB') {
            element.activate = false;
            element.fileName = '';
            element.oneTime = '';
            element.monthly = '';
          }
        });
      }
      if (mspScreenData != null) {
        if (mspScreenData.miscProductService.totalManagedServiceOneTimeFees != '' || mspScreenData.mspFeesummaryTotal != '') {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'MSP') {
              element.activate = true;
              element.fileName = this.dataService.ProposalTable.mspForm.ClientCode + '-SOW-' + (element.sowNo != '' ? element.sowNo.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) : '00') + '-' + element.name + '-' + this.dataService.ProposalTable.mspForm.scenarioName + '-' + randomGenerator + '.pdf';
              element.oneTime = mspScreenData.miscProductService.totalManagedServiceOneTimeFees;
              element.monthly = mspScreenData.mspFeesummaryTotal;
            }
          });
        }else {
          this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
            if (element.name == 'MSP') {
              element.activate = false;
              element.fileName = '';
              element.oneTime = '';
              element.monthly = '';
            }
          });
        }
      } else {
        this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
          if (element.name == 'MSP') {
            element.activate = false;
            element.fileName = '';
            element.oneTime = '';
            element.monthly = '';
          }
        });
      }
      if (this.dataService.ProposalTable.mspForm.ClientMsaLastName != '') {
        this.dataService.ProposalTable.mspForm.ClientFullName = this.dataService.ProposalTable.mspForm.ClientMsaSalutation + ' ' + this.dataService.ProposalTable.mspForm.ClientMsaFirstName + ' ' + this.dataService.ProposalTable.mspForm.ClientMsaLastName;
        this.dataService.ProposalTable.mspForm.ClientLastName = this.dataService.ProposalTable.mspForm.ClientMsaLastName;
        this.dataService.ProposalTable.mspForm.ClientSalutation = this.dataService.ProposalTable.mspForm.ClientMsaSalutation;
      } else {
        this.ClientCodeArr.forEach(element => {
          if (element.clientCode == this.dataService.ProposalTable.mspForm.ClientCode) {
            this.dataService.ProposalTable.mspForm.ClientFullName = element.salutation + ' ' + element.firstName + ' ' + element.lastName;
            this.dataService.ProposalTable.mspForm.ClientLastName = element.lastName;
            this.dataService.ProposalTable.mspForm.ClientSalutation = element.salutation;
          }
        });
      }
      this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
        if (element.overrideDate == null) {
          var classIds = '#' + element.name + 'OrDate' + " .wc-date-container span"
          jQuery(classIds).text("");
        }
        let index = this.activatedSheet.findIndex(item => item == element.name);
        if (element.activate == true && this.dataService.ProposalTable.mspForm.nextSowNo != '') {
          element.sowNo = parseFloat(this.dataService.ProposalTable.mspForm.nextSowNo) + index;
        } else {
          element.sowNo = ''
        }
      });
      jQuery(".sowDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.startDate != null ? this.dataService.ProposalTable.mspForm.startDate : '');
      jQuery(".msaNewDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.msaData.newDate != null ? this.dataService.ProposalTable.mspForm.newDate : '');
      jQuery(".msaExistingDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.msaData.existingDate != null ? this.dataService.ProposalTable.mspForm.msaData.existingDate : '');
      jQuery(".propslDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.proposalDate != null ? this.dataService.ProposalTable.mspForm.proposalDate : '');
      jQuery(".propslStartDate .wc-date-container span").text(this.dataService.ProposalTable.mspForm.proposedStartDate != null ? this.dataService.ProposalTable.mspForm.proposedStartDate : '');
      this.TotalOneTimeMonthlyCalc();
      localStorage.setItem("MSPForm", JSON.stringify(this.dataService.ProposalTable.mspForm));
      this.cdr.detectChanges();
    }
  }
  ReCalculation() {
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'SCREEN_CALCULATION', status: true});
  }
  PreviewSow(screenTab) {
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.name == screenTab && element.fileName != '' && this.dataService.ProposalTable.mspForm.noOfUsers != '' && this.dataService.ProposalTable.mspForm.noOfDevices != '' && this.dataService.ProposalTable.mspForm.noOfLocations != '' && this.dataService.ProposalTable.mspForm.Mailboxes != '' && this.dataService.ProposalTable.mspForm.ClientCode != '' && this.dataService.ProposalTable.mspForm.userCode != '' && this.dataService.ProposalTable.mspForm.nextSowNo != '') {
        if (element.overrideDate != null || this.dataService.ProposalTable.mspForm.startDate != null) {
          this.dataService.ClickedService.push(screenTab);
          this.dataService.broadcastInfo({ src: 'proposal-view', event: 'PREVIEW_SOW',  status: false ,params: screenTab});
        }
      }
    });
  }
  openTabComponent() {
    if (this.msaFileName == '' && this.dataService.ProposalTable.mspForm.noOfUsers != '' && this.dataService.ProposalTable.mspForm.noOfDevices != '' && this.dataService.ProposalTable.mspForm.noOfLocations != '' && this.dataService.ProposalTable.mspForm.Mailboxes != '' && this.dataService.ProposalTable.mspForm.ClientCode != '' && this.dataService.ProposalTable.mspForm.userCode != '') {
      this.dataService.broadcastInfo({ src: 'proposal-view', event: 'MSA_PREVIEW', status: false});      
      if (this.msaFileName == '') {
        let obj = {
          "contract_file_1_Id": this.dataService.dashboardContractId != '' ? this.dataService.dashboardContractId : '',
          "Contract_Date": this.dataService.ProposalTable.mspForm.msaData.newDate != null ? this.dataService.ProposalTable.mspForm.msaData.newDate : this.dataService.ProposalTable.mspForm.msaData.existingDate,
          "Client_": this.dataService.ProposalTable.mspForm.ClientCode,
          "Contract_type": 'MSA',
          "Contract_Status": "InProgress",
          "Filename": this.dataService.ProposalTable.mspForm.msaData.fileName,
          "status": "",
          "Tag": "",
          "Created_date": "",
          "Created_By": "",
          "Modified_By": "",
          "Modified_date": "",
          "jsonData": this.dataService.ProposalTable,
          "userid": 3280,
          "rptname": "contract_file_12095",
          "client": "starport1294"
        }
        let objData = { data: JSON.stringify(obj) }
        this.configApiService.saveContract(objData).subscribe(respdata => {
          if (respdata["_POST_AddMethodResult"].length > 0) {
            if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
              let resp = JSON.parse(respdata["_POST_AddMethodResult"][0].Ref_ID);
              this.dataService.dashboardContractId = resp.contract_file_12095.contract_file_1_Id;
            }
          }
        });
      }
    }
  }

  clearDate(event, inputName, index) {
    if (inputName == 'MSA_NEW_DATE') {
      this.dataService.ProposalTable.mspForm.msaData.newDate = this.datePipe.transform('', this.dateFormat);
      jQuery(".msaNewDate .wc-date-container span").text("");
    } else if (inputName == 'MSA_EXISTING_DATE') {
      this.dataService.ProposalTable.mspForm.msaData.existingDate = this.datePipe.transform('', this.dateFormat);
      jQuery(".msaExistingDate .wc-date-container span").text("");
    }else if (inputName == 'OVERRIDE_DATE') {
      let fieldId = event.concat('OrDate');
      this.dataService.ProposalTable.mspForm.dashboard[index].overrideDate = this.datePipe.transform('', this.dateFormat);
      jQuery('#' + fieldId + " .wc-date-container span").text("");
    }
  }

  selectImage(event) {
    this.dataService.ProposalTable.mspForm.userCode = event;
    this.userCode.forEach(elem => {
      if (elem.User_Name == event) {
        this.dataService.ProposalTable.mspForm.userSignature = elem.signature;
        this.dataService.ProposalTable.mspForm.userName = elem.Full_Name;
        this.dataService.ProposalTable.mspForm.userDesignation = elem.Destination;
        var filename = this.dataService.ProposalTable.mspForm.userSignature.split('/').pop()
        var body = { "fileName": filename }
        this.configApiService.downloadFile(body, this.cbk);
      }
    });
  }
  TotalOneTimeMonthlyCalc() {
    let oneTimeArray = [];
    let MonthlyArray = [];
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.oneTime != '') {
        oneTimeArray.push(parseFloat(element.oneTime.slice(1).replace(/  |,/gi, "")));
      } else {
        oneTimeArray.push(DEFAULTVALUE);
      }
      if (element.monthly != '') {
        MonthlyArray.push(parseFloat(element.monthly.slice(1).replace(/  |,/gi, "")));
      } else {
        MonthlyArray.push(DEFAULTVALUE);
      }
    });
    var value = oneTimeArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    var value1 = MonthlyArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if (value != DEFAULTVALUE) {
      this.dataService.ProposalTable.mspForm.totalDashboardOneTime = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.mspForm.totalDashboardOneTime = '';
    }
    if (value1 != DEFAULTVALUE) {
      this.dataService.ProposalTable.mspForm.totalDashboardMonthly = '$' + value1.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.mspForm.totalDashboardMonthly = '';
    }
  }
  previewSowPdf(tabName) {
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.name == tabName && element.fileName != '' && this.dataService.ProposalTable.mspForm.noOfUsers != '' && this.dataService.ProposalTable.mspForm.noOfDevices != '' && this.dataService.ProposalTable.mspForm.noOfLocations != '' && this.dataService.ProposalTable.mspForm.Mailboxes != '' && this.dataService.ProposalTable.mspForm.ClientCode != '' && this.dataService.ProposalTable.mspForm.userCode != '' && this.dataService.ProposalTable.mspForm.nextSowNo != '') {
        if (element.overrideDate != null || this.dataService.ProposalTable.mspForm.startDate != null) {
          this.dataService.ClickedService.push(tabName);
          this.dataService.broadcastInfo({ src: 'proposal-view', event: 'SOW_PREVIEW', status: false, params: element, index: ''});
        }
      }
    });
  }
  publishSow(){
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.activate == true) {
        if (this.dataService.publishContract.includes(element) == false) {
          this.dataService.publishContract.push(element);
        }
      }
    });
    this.dataService.broadcastInfo({ src: 'proposal-view', event: 'SOW_PREVIEW', status: true, params: this.dataService.publishContract[this.publishCount], index: this.publishCount});
    }
  ClearSL(sheetId, sheetName) {
    var data = JSON.parse(this.dataService.dataTable);
    this.dataService.ProposalTable[sheetId] = data[sheetId];
    let ind = this.dataService.ProposalTable.mspForm.dashboard.findIndex(item => item.id == sheetId);
    this.dataService.ProposalTable.mspForm.dashboard[ind] = data.mspForm.dashboard[ind];
    var allDevices;
    var allBackupDevices;
    this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
      if (element.id == sheetId) {
        element.overrideDate = null;
        var classIds = '#' + element.name + 'OrDate' + " .wc-date-container span"
        jQuery(classIds).text("");
      }
      if (sheetId == 'mspPricingSheet') {
        this.dataService.ProposalTable.AllIntronis = data.AllIntronis;
        this.dataService.ProposalTable.AllDatto = data.AllDatto;
        this.dataService.ProposalTable.MspDattoIntronis = data.MspDattoIntronis;
        allDevices = {
          "dattoConnectedDevices": this.dataService.ProposalTable.MspDattoIntronis.noOfDattoDevices,
          "dattoOneTime": this.dataService.ProposalTable.MspDattoIntronis.totalDattoOneTimePurchase == undefined ? '' : this.dataService.ProposalTable.MspDattoIntronis.totalDattoOneTimePurchase,
          "intronisConnectedDevices": this.dataService.ProposalTable.MspDattoIntronis.noOfIntronisDevices,
          "intronisOneTime": this.dataService.ProposalTable.MspDattoIntronis.totalIntronisOneTimePurchase == undefined ? '' : this.dataService.ProposalTable.MspDattoIntronis.totalIntronisOneTimePurchase,
          "dattoMonthlyPrice": this.dataService.ProposalTable.MspDattoIntronis.totalDattoPrice == undefined ? '' : this.dataService.ProposalTable.MspDattoIntronis.totalDattoPrice,
          "intronisMonthlyPrice": this.dataService.ProposalTable.MspDattoIntronis.totalIntronisPrice == undefined ? '' : this.dataService.ProposalTable.MspDattoIntronis.totalIntronisPrice
        }
      } else if (sheetId == 'backupDrPricingSheet') {
        this.dataService.ProposalTable.BackupDrAllIntronis = data.BackupDrAllIntronis;
        this.dataService.ProposalTable.BackupDrAllDatto = data.BackupDrAllDatto;
        this.dataService.ProposalTable.BackupDrDattoIntronis = data.BackupDrDattoIntronis;
        allBackupDevices = {
          "dattoConnectedDevices": this.dataService.ProposalTable.BackupDrDattoIntronis.noOfDattoDevices,
          "dattoOneTime": this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoOneTimePurchase == undefined ? '' : this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoOneTimePurchase,
          "intronisConnectedDevices": this.dataService.ProposalTable.BackupDrDattoIntronis.noOfIntronisDevices,
          "intronisOneTime": this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisOneTimePurchase == undefined ? '' : this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisOneTimePurchase,
          "dattoMonthlyPrice": this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoPrice == undefined ? '' : this.dataService.ProposalTable.BackupDrDattoIntronis.totalDattoPrice,
          "intronisMonthlyPrice": this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisPrice == undefined ? '' : this.dataService.ProposalTable.BackupDrDattoIntronis.totalIntronisPrice
        }
      }
    });
    localStorage.setItem('SelectedDevices', JSON.stringify(allDevices));
    localStorage.setItem('BackupDrSelectedDevices', JSON.stringify(allBackupDevices));
    localStorage.setItem("AllDatto", JSON.stringify(this.dataService.ProposalTable.AllDatto));
    localStorage.setItem("AllIntronis", JSON.stringify(this.dataService.ProposalTable.AllIntronis));
    localStorage.setItem("BackupDrAllDatto", JSON.stringify(this.dataService.ProposalTable.BackupDrAllDatto));
    localStorage.setItem("BackupDrAllIntronis", JSON.stringify(this.dataService.ProposalTable.BackupDrAllIntronis));
    localStorage.setItem("MSPForm", JSON.stringify(this.dataService.ProposalTable.mspForm));
    localStorage.setItem('MSPScreenData', JSON.stringify(this.dataService.ProposalTable.mspPricingSheet));
    localStorage.setItem('CYBERScreenData', JSON.stringify(this.dataService.ProposalTable.cyberPricingSheet));
    localStorage.setItem('CLOUDScreenData', JSON.stringify(this.dataService.ProposalTable.cloudPricingSheet));
    localStorage.setItem('BACKUPDRsScreenData', JSON.stringify(this.dataService.ProposalTable.backupDrPricingSheet));
    localStorage.setItem('HWSWScreenData', JSON.stringify(this.dataService.ProposalTable.hwswHaasSaasSheet));
    localStorage.setItem('ProjectScreen', JSON.stringify(this.dataService.ProposalTable.projectScreen));
  }
  PublishMsa() {
    if (this.msaFileName == '') {
      let obj = {
        "contract_file_1_Id": this.dataService.dashboardContractId != '' ? this.dataService.dashboardContractId : '',
        "Contract_Date": this.dataService.ProposalTable.mspForm.msaData.newDate != null ? this.dataService.ProposalTable.mspForm.msaData.newDate : this.dataService.ProposalTable.mspForm.msaData.existingDate,
        "Client_": this.dataService.ProposalTable.mspForm.ClientCode,
        "Contract_type": 'MSA',
        "Contract_Status": "Published",
        "Filename": this.dataService.ProposalTable.mspForm.msaData.fileName,
        "status": "",
        "Tag": "",
        "Created_date": "",
        "Created_By": "",
        "Modified_By": "",
        "Modified_date": "",
        "jsonData": this.dataService.ProposalTable,
        "userid": 3280,
        "rptname": "contract_file_12095",
        "client": "starport1294"
      }
      let objData = { data: JSON.stringify(obj) }
      this.configApiService.saveContract(objData).subscribe(respdata => {
        if (respdata["_POST_AddMethodResult"].length > 0) {
          if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
            let resp = JSON.parse(respdata["_POST_AddMethodResult"][0].Ref_ID);
            this.dataService.dashboardContractId = resp.contract_file_12095.contract_file_1_Id;
            const toast = this.toastController.create({
              message: 'MSA Contract has been Published',
              duration: 1000,
            });
            toast.present();
            this.dataService.broadcastInfo({ src: 'proposal-view', event: 'MSA_PREVIEW', status: true});      
          }
        }
      });
    }
  }
  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.dataService.ProposalTable.mspForm.ClientLogo = reader.result;
      }
    }
  }
  PropsalTitle(event) {
    this.dataService.ProposalTable.mspForm.proposalTitle = event.target.value;
  }
  openProposal() {
    this.showProposal = true;
    setTimeout(() => {
      const componentFactory = this.resolver.resolveComponentFactory(ProposalComponent);
      this.viewContainerRef.clear();
      this.componentRef = this.viewContainerRef.createComponent(componentFactory);
      // this.componentRef.instance.returnBack.subscribe(() => { this.cleadExcelComponent(); });
    }, 100);
  }
  cleadExcelComponent() {
    this.showProposal = false;
  }
  previewPpsl() {
    // if(this.activatedSheet.length > 0 &&this.dataService.ProposalTable.mspForm.proposalFileName != '' && this.dataService.ProposalTable.mspForm.proposalTitle != '' && this.dataService.ProposalTable.mspForm.proposalDate != null && this.dataService.ProposalTable.mspForm.proposalDate != '' &&  this.dataService.ProposalTable.mspForm.noOfUsers != '' && this.dataService.ProposalTable.mspForm.noOfDevices != '' && this.dataService.ProposalTable.mspForm.noOfLocations != '' && this.dataService.ProposalTable.mspForm.Mailboxes != '' && this.dataService.ProposalTable.mspForm.ClientCode != '' && this.dataService.ProposalTable.mspForm.userCode != ''){
    //   this.event.publish("ProposalPreview",  this.activatedSheet, true);
    // }
  }
  ClearPpsl() {
    const toast = this.toastController.create({
      message: 'Proposal has been Cleared',
      duration: 1000,
    });
    toast.present();
  }

  AddClientDetails() {
    let myModal = this.modalCtrl.create(AddClientDetailsComponent);
    myModal.onDidDismiss(data => {
    })
    myModal.present();
  }
  ngOnDestroy() {
    this.broadcastSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/cover-screen/cover-screen.ts